import React from 'react';


export function Japan(props) {
	return (
		<svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_301_933)">
				<path d="M0 -0.00927734H513V341.994H0V-0.00927734Z" fill="#f3f3f3" />
				<path d="M256.5 267.174C309.623 267.174 352.688 224.11 352.688 170.987C352.688 117.864 309.623 74.7993 256.5 74.7993C203.377 74.7993 160.312 117.864 160.312 170.987C160.312 224.11 203.377 267.174 256.5 267.174Z" fill="#D80027" />
			</g>
			<defs>
				<clipPath id="clip0_301_933">
					<rect width="513" height="342" fill="white" transform="translate(0 -0.00732422)" />
				</clipPath>
			</defs>
		</svg>


	);
} 